import PropTypes from 'prop-types';
import React, { memo } from 'react';

/**
 * Stateless component for result counter.
 *
 * @param props {Object}.
 * @param props.total {number} Total result row.
 * @param props.showing {number} Showing result row.
 */
const CounterComponent = ({ total, showing }) => (
  <span className="text-nowrap">
    {total} total - showing {showing}
  </span>
);

CounterComponent.propTypes = {
  showing: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export const Counter = memo(CounterComponent);
